/**
 * range
 * @description startからendまでの配列を作成する
 * @param start
 * @param end
 * @returns number[]
 */

export const range = (start: number, end: number) => {
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

/**
 * dateRange
 * @description dateからdays分の日付の配列を作成する
 * @param date
 * @param days
 * @returns string[]
 * @example dateRange(new Date('2021-01-01'), 3)
 * // => ['2021/1/1', '2021/1/2', '2021/1/3']
 * @warning 書式は `formatSlashDate`（ロケール非依存）で固定する。
 *          `toLocaleDateString()` はブラウザの言語設定で書式が変わり、
 *          戻り値がお届け日として API に送られるため注文が失敗する（R_D-3342）。
 */

export const dateRange = (date: Date, days: number) => {
  return range(0, days - 1).map((i) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + i);
    return formatSlashDate(newDate);
  });
};

/**
 * dateRangeFromDates
 * @description startDateからendDateまでの日付の配列を作成する
 * @param startDate
 * @param endDate
 * @returns string[]
 * @example dateRangeFromDates(new Date('2021-01-01'), new Date('2021-01-03'))
 * // => ['2021/1/1', '2021/1/2', '2021/1/3']
 */

export const dateRangeFromDates = (startDate: Date, endDate: Date) => {
  const days = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
  return dateRange(startDate, days);
};

/**
 * generateNextDecadeYears
 * @description 今年から10年先の西暦の下二桁を表す文字列の配列を生成する
 * @return string[] 西暦の下二桁を表す文字列の配列
 * @warning 2088年以降、この関数は正しく動作しない可能性があります
 */
export const generateNextDecadeYears = (): ReadonlyArray<string> => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear % 100;
  const endYear = startYear + 10;
  const years = range(startYear, endYear).map((year) => year.toString().padStart(2, '0'));
  return years;
};
